import _ from "lodash";

export const hideTotals = (order) => {
  return order.summary.orderType === "TEAMWEAR";
};

export const calculateTotals = (order, products, totalObject) => {
  if (!totalObject) return {};
  const orderDiscount = parseFloat(order.discount || 0) / 100.0;

  return {
    quantitySum: _.reduce(
      _.compact(_.flatten(products)),
      (total, current) => total + current.amount,
      0,
    ),
    totalWithoutRebate: totalObject.total,
    rebateAmount: totalObject.total * (orderDiscount || 0),
    sumWithRebate: totalObject.total * (1 - orderDiscount || 0),
  };
};
